var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99 4.662C5.157 2.18 7.203.155 9.687.01c2.902-.167 5.323 2.128 5.303 5.008a5.01 5.01 0 0 1-5.01 5.008c-2.882 0-5.178-2.441-4.99-5.363zm-4.99 12c0-3.34 6.66-5.01 10-5.01s10 1.67 10 4.988v2.525c0 .46-.376.835-.835.835H.835A.837.837 0 0 1 0 19.165v-2.504z"
  }))));
};
export default SvgUser;